import React from "react";
import Importcompo from "../components/Importcompo";

function Export() {
  return <div>
    <Importcompo title="Export"/>
  </div>;
}

export default Export;
